const BASE_ORIGIN = 'https://amerikooler.local';

function isSafeShape(value: string): boolean {
  return (
    !!value &&
    value.startsWith('/') &&
    !value.startsWith('//') &&
    !value.includes('\\') &&
    !/^\/[\\/]/.test(value)
  );
}

export function safeInternalReturnPath(value: string | null | undefined): string | null {
  if (!value || !isSafeShape(value)) return null;

  try {
    const parsed = new URL(value, BASE_ORIGIN);
    if (parsed.origin !== BASE_ORIGIN || parsed.pathname === '/login') return null;

    const normalized = `${parsed.pathname}${parsed.search}${parsed.hash}`;
    // Re-validate the normalized result: dot-segments or encoded input can
    // normalize into a protocol-relative/external-looking path.
    if (!isSafeShape(normalized)) return null;

    const reparsed = new URL(normalized, BASE_ORIGIN);
    if (reparsed.origin !== BASE_ORIGIN || reparsed.pathname === '/login') return null;

    return normalized;
  } catch {
    return null;
  }
}

export function buildConfirmationReturnUrl(origin: string, returnPath?: string | null): string {
  const safeReturn = safeInternalReturnPath(returnPath);
  if (!safeReturn) return origin;
  const params = new URLSearchParams({ redirect: safeReturn });
  return `${origin}/login?${params.toString()}`;
}
